import React from "react";

export const MenuIcon = ({
  height = "26",
  width = "32",
}: {
  height?: string;
  width?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 0.555542C15.5285 0.555542 15.0763 0.742843 14.7429 1.07624C14.4095 1.40964 14.2222 1.86182 14.2222 2.33332C14.2222 2.80482 14.4095 3.257 14.7429 3.5904C15.0763 3.9238 15.5285 4.1111 16 4.1111H30.2222C30.6937 4.1111 31.1459 3.9238 31.4793 3.5904C31.8127 3.257 32 2.80482 32 2.33332C32 1.86182 31.8127 1.40964 31.4793 1.07624C31.1459 0.742843 30.6937 0.555542 30.2222 0.555542H16Z"
      fill="#595959"
    />
    <path
      d="M7.11111 13C7.11111 12.5285 7.29842 12.0763 7.63181 11.7429C7.96521 11.4095 8.4174 11.2222 8.88889 11.2222H23.1111C23.5826 11.2222 24.0348 11.4095 24.3682 11.7429C24.7016 12.0763 24.8889 12.5285 24.8889 13C24.8889 13.4715 24.7016 13.9237 24.3682 14.2571C24.0348 14.5905 23.5826 14.7778 23.1111 14.7778H8.88889C8.4174 14.7778 7.96521 14.5905 7.63181 14.2571C7.29842 13.9237 7.11111 13.4715 7.11111 13Z"
      fill="#595959"
    />
    <path
      d="M0 23.6666C0 23.1951 0.187301 22.743 0.520699 22.4096C0.854097 22.0762 1.30628 21.8889 1.77778 21.8889H16C16.4715 21.8889 16.9237 22.0762 17.2571 22.4096C17.5905 22.743 17.7778 23.1951 17.7778 23.6666C17.7778 24.1381 17.5905 24.5903 17.2571 24.9237C16.9237 25.2571 16.4715 25.4444 16 25.4444H1.77778C1.30628 25.4444 0.854097 25.2571 0.520699 24.9237C0.187301 24.5903 0 24.1381 0 23.6666Z"
      fill="#595959"
    />
  </svg>
);